import React from "react";
import { Avatar, Header } from "./style";
import { Link } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import AvatarUser from "./AvatarUser";

const NavBar = () => {
  return (
    <>
      <Header>
        <div id="header-wrap">
          <Navbar className="bg-transparent" expand="lg">
            <Navbar.Brand className="text-white brand-title" href="/">
              <Link to={"/"}>
                <div className="logo" />{" "}
              </Link>
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ml-auto">
                <Link className="nav-link text-white ml-5" to={"/howworks"}>
                  HOW IT WORKS
                </Link>
                {/* <Link className="nav-link text-white ml-5" to={"/reefresorts"}>REEF RESORT & SPA</Link> */}
                <Link className="nav-link text-white ml-5" to={"/travel"}>
                  LVC TRAVEL YOUR WAY
                </Link>
                <Link className="nav-link text-white ml-5" to={"/"}>
                  MY WALLET
                </Link>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </div>

        <Avatar className="nomargin nopadding">
          <AvatarUser />
        </Avatar>
      </Header>
    </>
  );
};

export default NavBar;
